import React from 'react';
import PropTypes from 'prop-types'
import { Button } from 'reactstrap';

const BusMaintenanceStayClearButton = ({
  handleClearRow,
  busMaintenanceStay,
}) => {

  const isModified = busMaintenanceStay.modified;
  const isMarkedForDelete = busMaintenanceStay.markedForDelete;
  return (
    <>
      {(isModified || isMarkedForDelete) && (
        <Button
          color="warning"
          outline
          onClick={() => handleClearRow(busMaintenanceStay)}
          title="Deshacer cambios"
        >
          <i className="fa fa-times" />
        </Button>
      )
      }
    </>
  )
}

BusMaintenanceStayClearButton.propTypes = {
  handleClearRow: PropTypes.func.isRequired,
  busMaintenanceStay: PropTypes.shape({
    modified: PropTypes.bool,
    markedForDelete: PropTypes.bool,
  }).isRequired,
}

export default BusMaintenanceStayClearButton
